import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768): boolean {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const sync = () => setIsMobile(mql.matches);

    // Re-sincroniza inmediatamente al montar: el valor leído por el lazy
    // initializer de useState puede haber quedado desactualizado para
    // cuando este efecto corre (p.ej. viewport cambiado antes del primer
    // render estable).
    sync();
    mql.addEventListener("change", sync);
    // Fallback: algunos navegadores mobile y el device-emulation de
    // DevTools no disparan el evento "change" de matchMedia de forma
    // confiable tras el primer render.
    window.addEventListener("resize", sync);

    return () => {
      mql.removeEventListener("change", sync);
      window.removeEventListener("resize", sync);
    };
  }, [query]);

  return isMobile;
}
